import { normalizePath } from './route-pattern';

const PRIORITY_PAGE_PATTERNS = [
  /\/dashboard\/collection-items(?:\/template\/[^/]+)?$/,
  /\/dashboard\/collection-items\/fill\/[^/]+(?:\/[^/]+)?$/,
  /\/dashboard\/file-manager(?:\/[^/]+)?$/,
];

export function resolveTraceSampleRate(
  defaultSampleRate: number,
  pageSampleRate: number,
  ...routeCandidates: Array<string | undefined>
): number {
  const isPriorityPage = routeCandidates.some(candidate => candidate && matchesPriorityPage(candidate));
  return isPriorityPage ? Math.max(defaultSampleRate, pageSampleRate) : defaultSampleRate;
}

function matchesPriorityPage(candidate: string): boolean {
  const path = normalizePath(candidate.split('?')[0].split('#')[0]);
  return PRIORITY_PAGE_PATTERNS.some(pattern => pattern.test(path));
}
